import { render } from "./Top-LogoImages.vue?vue&type=template&id=4b226084&scoped=true"
import script from "./Top-LogoImages.vue?vue&type=script&lang=js"
export * from "./Top-LogoImages.vue?vue&type=script&lang=js"

import "./Top-LogoImages.vue?vue&type=style&index=0&id=4b226084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b226084"]])

export default __exports__